import {
    FETCH_SUBMITTED_FOR_VERIFICATION_START,
    FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS,
    FETCH_SUBMITTED_FOR_VERIFICATION_ERROR,
    SET_MRT_SFV_FILTER,
    SET_SFV_AUTO_NEXT_VISIT,
    SET_SUBMITTED_FOR_VERIFICATION_PAGINATION,
    VIEW_SFV_VISIT_LOADING_START,
    VIEW_SFV_VISIT_LOADING_END,
    RESET_SFV_FILTER
} from '../../actions/mrt/submittedForVerificationAction';

import {
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS

} from "../../actions/mrt/reportViewerAction";
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    submittedForVerification: [],
    autoNextVisit: false,
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "desc" }],
    skippedVisits: []
};

const submittedForVerificationReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_SUBMITTED_FOR_VERIFICATION_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, submittedForVerification: action.submittedForVerification };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS: {
            return { ...state, error: '', message: '' };
        }
        case SET_MRT_SFV_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }
        case SET_SFV_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }

        case SET_SUBMITTED_FOR_VERIFICATION_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case VIEW_SFV_VISIT_LOADING_START: {
            return { ...state, loading: true };
        }
        case VIEW_SFV_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }

        case RESET_SFV_FILTER: {
            newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }

        default:
            return state;
    }
}

export default submittedForVerificationReducer;
